module.exports = __webpack_public_path__ + "img/SANTAS HAT 2.95d14b1.svg";